
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45.332","height":"45.332","viewBox":"0 0 11.994 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.99 6A5.997 5.997 0 11-.005 6 5.997 5.997 0 1111.99 6","fill":"#e6e6e6"}}),_c('g',{attrs:{"fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":".388"}},[_c('g',{attrs:{"stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.08 6.53H3.512a.217.217 0 01-.217-.217v-.111c0-.12.097-.217.217-.217H9.08c.12 0 .217.097.217.217v.111c0 .12-.097.217-.217.217zM9.08 3.46H3.513a.218.218 0 01-.218-.218v-.113c0-.12.098-.219.218-.219H9.08c.12 0 .218.098.218.219v.113c0 .12-.098.218-.218.218zM6.29 9.06v.572M2.43 10.46h2.98M7.15 10.46h2.98M7.15 10.48a.853.853 0 10-1.707 0 .853.853 0 001.707 0zM8.66 8.31a.491.491 0 110-.983.491.491 0 010 .983zm1.19-1.78H2.737a.172.172 0 00-.172.172v2.183c0 .094.077.171.172.171h7.111a.172.172 0 00.172-.171V6.702a.172.172 0 00-.172-.172z"}}),_c('path',{attrs:{"d":"M8.66 5.19a.491.491 0 110-.983.491.491 0 010 .983zm1.19-1.74H2.737a.172.172 0 00-.172.172v2.182c0 .095.077.172.172.172h7.111a.172.172 0 00.172-.172V3.622a.172.172 0 00-.172-.173zM8.66 2.13a.492.492 0 110-.983.492.492 0 010 .983zM9.85.377H2.737a.172.172 0 00-.172.172V2.73c0 .095.077.172.172.172h7.111a.172.172 0 00.172-.172V.55a.172.172 0 00-.172-.172z"}})]),_c('path',{attrs:{"d":"M4.93 1.61h.125v.125H4.93zM3.72 1.61h.125v.125H3.72zM4.93 4.67h.125v.125H4.93zM3.72 4.67h.125v.125H3.72zM4.93 7.8h.125v.125H4.93zM3.72 7.8h.125v.125H3.72z"}})])])
          )
        }
      }
    